const RESULTS_PER_PAGE = 10;

export default RESULTS_PER_PAGE;
